/* eslint-disable react/style-prop-object */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Utils from '../../../misc/Utils';
import { Empty, Spin } from 'antd';
import {
   Chart as ChartJS,
   CategoryScale,
   LinearScale,
   BarElement,
   Title,
   Tooltip,
   Legend,
} from 'chart.js';
import { Bar } from "react-chartjs-2";
import { InterpretationInd, IntroInd } from '../components';
import DiagnosticReportUtils from '../../../misc/DiagnosticReportUtils';

export function MTLanguageKReport(props) {
   const [reportData, setReportData] = useState(null);
   const [reportPPData, setReportPPData] = useState({});

   const [knowing, setKnowing] = useState(null);
   const [exploring, setExploring] = useState(null);
   const [appreciating, setAppreciating] = useState(null);
   const [caring, setCaring] = useState(null);
   const [dataLoading, setDataLoading] = useState(false);

   useEffect(() => {
      Utils.verifyJwt();

      ChartJS.register(
         CategoryScale,
         LinearScale,
         BarElement,
         Title,
         Tooltip,
         Legend
      );

      // getReport(props.subject_id, props.assignment_id, props.student_id, props.template);
      getReport(props.subject_id, props.assessment_id, props.student_id, props.template);
   }, []);

   const getReport = (subject, assignment_id, student_id, template) => {
      setDataLoading(true);
      var url = `${process.env.REACT_APP_API_BRAINEE_DIAGNOSTIC}/getdiagnosticreport?s=${subject}&ai=${assignment_id}&si=${student_id}&t=${template}`;

      axios.get(url).then((response) => {
         console.log(response);

         if (response.data) {
            const data = response.data[0];

            if (data !== undefined) {
               setKnowing(data.s1 + data.s2 + data.s3 + data.s4 + data.s5 + data.s6 + data.s7);
               setExploring(data.s8 + data.s9 + data.s10 + data.s11 + data.s12 + data.s13);
               setAppreciating(data.s14 + data.s15 + data.s16 + data.s17);
               setCaring(data.s18 + data.s19 + data.s20);

               setReportData(data);
               var ppData = {
                  Pre: response.data.filter(item => item.diagnostic_type === 'pre'),
                  Post: response.data.filter(item => item.diagnostic_type === 'post'),
               }

               setReportPPData(ppData);
            }

            setDataLoading(false);
         }
      }, (error) => {
         setDataLoading(false);
         console.log(error.message);
      });
      // }
   }

   const graph_options = {
      responsive: true,
      plugins: {
         legend: {
            position: 'top',
         },
         title: {
            display: true,
            text: 'Percent Correct for the Content Standards',
         },
      },
      scales: {
         y:
         {
            min: 0,
            max: 100,
            stepSize: 1,
         },
         x:
            {},
      }
   };
   const labels = ["Knowing who we are and our families", "Exploring my Community", "Appreciating our Country", "Caring for the World"];
   const graph_data = {
      labels: labels,
      datasets: [
         {
            label: "Percentage",
            backgroundColor: "#4F81BD",
            borderColor: "#4F81BD",
            data: [
               !isNaN((knowing / 7) * 100) ? ((knowing / 7) * 100).toFixed(2) : 0,
               !isNaN((exploring / 6) * 100) ? ((exploring / 6) * 100).toFixed(2) : 0,
               !isNaN((appreciating / 4) * 100) ? ((appreciating / 4) * 100).toFixed(2) : 0,
               !isNaN((caring / 3) * 100) ? ((caring / 3) * 100).toFixed(2) : 0
            ],
         },
      ],
   };

   return (
      <>
         {
            dataLoading
               ?
               <div className='center-empty-space'>
                  <Spin size='large' tip="Loading data, please wait..." />
               </div>
               :
               reportData !== null
                  ?
                  <div className="dashboard-item-inner3" style={{ padding: '7px' }}>
                     <div style={{ fontFamily: 'calibri' }} id='individual-report'>

                        <IntroInd
                           subject='Language'
                           grade_level={reportData.grade_level}
                           student_name={reportData.student_name}
                           school_name={reportData.school_name}
                           section={reportData.section}
                           diagnostic_date={reportData.diagnostic_date}
                        />

                        <p style={{ marginTop: '0pt', marginBottom: '0pt', lineHeight: 'normal', fontSize: '10pt' }}><strong>&nbsp;</strong></p>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', lineHeight: 'normal', fontSize: '12pt' }}><strong>Competency Score</strong></p>
                        <div style={{ textAlign: 'center' }}>
                           <table cellSpacing={0} cellPadding={0} style={{ marginRight: 'auto', marginLeft: 'auto', border: '0.75pt solid #cccccc', borderCollapse: 'collapse', width: '100%' }}>
                              <tbody>
                                 <tr>
                                    <td style={{ width: '12.6pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>&nbsp;</span></strong></p>
                                    </td>
                                    <td style={{ width: '382.3pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>Learning Competency</span></strong></p>
                                    </td>
                                    <td style={{ width: '31.7pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>Score</span></strong></p>
                                    </td>
                                    <td style={{ width: '81pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>Pretest Percent Correct for the Level</span></strong></p>
                                    </td>
                                    <td style={{ width: '81pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>Posttest Percent Correct for the Level</span></strong></p>
                                    </td>
                                 </tr>
                                 {DiagnosticReportUtils.renderPartLabel("Part 1: Knowing who we are and our families")}
                                 {DiagnosticReportUtils.renderCompetencyRow("1", "Identify one’s given name, friends' names, their family members, and common things they use that are found at home;", reportData, reportPPData.Pre[0], reportPPData.Post[0], 1)}
                                 {DiagnosticReportUtils.renderCompetencyRow("2", "Produce the sound of the letter it stands for", reportData, reportPPData.Pre[0], reportPPData.Post[0], 2)}
                                 {DiagnosticReportUtils.renderCompetencyRow("3", "Produce the sound of the letter it stands for", reportData, reportPPData.Pre[0], reportPPData.Post[0], 3)}
                                 {DiagnosticReportUtils.renderCompetencyRow("4", "Write the letters of the alphabet in uppercase and lowercase form", reportData, reportPPData.Pre[0], reportPPData.Post[0], 4)}
                                 {DiagnosticReportUtils.renderCompetencyRow("5", "Write the letters of the alphabet in uppercase and lowercase form", reportData, reportPPData.Pre[0], reportPPData.Post[0], 5)}
                                 {DiagnosticReportUtils.renderCompetencyRow("6", "Narrate one’s personal experiences", reportData, reportPPData.Pre[0], reportPPData.Post[0], 6)}
                                 {DiagnosticReportUtils.renderCompetencyRow("7", "Use polite greetings and courteous expressions in appropriate situations", reportData, reportPPData.Pre[0], reportPPData.Post[0], 7)}

                                 {DiagnosticReportUtils.renderPartLabel("Part 2: Exploring my community")}
                                 {DiagnosticReportUtils.renderCompetencyRow("8", "Recognize that sounding off letters form words", reportData, reportPPData.Pre[0], reportPPData.Post[0], 8)}
                                 {DiagnosticReportUtils.renderCompetencyRow("9", "Recognize that sounding off letters form words", reportData, reportPPData.Pre[0], reportPPData.Post[0], 9)}
                                 {DiagnosticReportUtils.renderCompetencyRow("10", "Identify familiar sounds in the environment", reportData, reportPPData.Pre[0], reportPPData.Post[0], 10)}
                                 <div style={{ pageBreakBefore: 'always' }}></div>
                                 {DiagnosticReportUtils.renderCompetencyRow("11", "Describe the different places and persons belonging in one’s community", reportData, reportPPData.Pre[0], reportPPData.Post[0], 11)}
                                 {DiagnosticReportUtils.renderCompetencyRow("12", "Give the correct sequence of events in a local text listened to;", reportData, reportPPData.Pre[0], reportPPData.Post[0], 12)}
                                 {DiagnosticReportUtils.renderCompetencyRow("13", "Tell the names of the days in a week and months in a year", reportData, reportPPData.Pre[0], reportPPData.Post[0], 13)}

                                 {DiagnosticReportUtils.renderPartLabel("Part 3: Appreciating our Country")}
                                 {DiagnosticReportUtils.renderCompetencyRow("14", "Participate in dialogues or conversations about familiar events", reportData, reportPPData.Pre[0], reportPPData.Post[0], 14)}
                                 {DiagnosticReportUtils.renderCompetencyRow("15", "Identify solutions to a problem based on a local text listened to", reportData, reportPPData.Pre[0], reportPPData.Post[0], 15)}
                                 {DiagnosticReportUtils.renderCompetencyRow("16", "Identify solutions to a problem based on a local text listened to", reportData, reportPPData.Pre[0], reportPPData.Post[0], 16)}
                                 {DiagnosticReportUtils.renderCompetencyRow("17", "Identify solutions to a problem based on a local text listened to", reportData, reportPPData.Pre[0], reportPPData.Post[0], 17)}

                                 {DiagnosticReportUtils.renderPartLabel("Part 4: Caring for the World")}
                                 {DiagnosticReportUtils.renderCompetencyRow("18", "Predict outcomes based on any given situation;", reportData, reportPPData.Pre[0], reportPPData.Post[0], 18)}
                                 {DiagnosticReportUtils.renderCompetencyRow("19", "Predict outcomes based on any given situation;", reportData, reportPPData.Pre[0], reportPPData.Post[0], 19)}
                                 {DiagnosticReportUtils.renderCompetencyRow("20", "Predict outcomes based on any given situation;", reportData, reportPPData.Pre[0], reportPPData.Post[0], 20)}

                              </tbody>
                           </table>
                        </div>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', lineHeight: 'normal' }}><strong>&nbsp;</strong></p>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', lineHeight: 'normal', fontSize: '10pt' }}><a name="_Hlk103365502"><strong>Summary of Results.</strong>&nbsp; The result for the content standards is expressed in terms of the raw score, percent correct, standard score, and proficiency level.&nbsp;</a></p>
                        <ul type="disc" style={{ margin: '0pt', paddingLeft: '0pt' }}>
                           <li style={{ marginLeft: '9.6pt', lineHeight: 'normal', paddingLeft: '8.4pt', fontFamily: 'serif', fontSize: '10pt', textAlign: 'justify' }}><strong><span style={{ fontFamily: 'Calibri' }}>Raw Score.</span></strong><span style={{ fontFamily: 'Calibri' }}>&nbsp;&nbsp;</span><span style={{ fontFamily: 'Calibri' }}>The raw score is the total number of correct answers for the content standard.&nbsp;</span></li>
                           <li style={{ marginLeft: '9.6pt', lineHeight: 'normal', paddingLeft: '8.4pt', fontFamily: 'serif', fontSize: '10pt', textAlign: 'justify' }}><strong><span style={{ fontFamily: 'Calibri' }}>Percent Correct.</span></strong><span style={{ fontFamily: 'Calibri' }}>&nbsp;&nbsp;</span><span style={{ fontFamily: 'Calibri' }}>The percent correct is the raw score converted into percentage. The percent correct provides you with an easier way to determine how many correct answers you are able to obtain for each content standard. If the percent correct is close to 100%, the more correct answers you are able to attain.</span></li>
                           <li style={{ marginLeft: '9.6pt', lineHeight: 'normal', paddingLeft: '8.4pt', fontFamily: 'serif', fontSize: '10pt', textAlign: 'justify' }}><strong><span style={{ fontFamily: 'Calibri' }}>Standard score.</span></strong><span style={{ fontFamily: 'Calibri' }}>&nbsp;The scores are converted into a standard score to allow comparison of scores across content standards and across levels. A standard score near 0.0 means that the learner’s standing in the content standard is within the majority of the test takers. A standard score of more than 1.00 mean that the attainment of the competencies is high because there are several correct answers.&nbsp;</span></li>
                           <li style={{ marginLeft: '9.6pt', lineHeight: 'normal', paddingLeft: '8.4pt', fontFamily: 'serif', fontSize: '10pt', textAlign: 'justify' }}><strong><span style={{ fontFamily: 'Calibri' }}>Proficiency Level.</span></strong><span style={{ fontFamily: 'Calibri' }}>&nbsp;The proficiency level describes your present level of attainment on content standard. The levels of proficiency start from beginner to basic to competent. The beginner level means few correct answers attained in the content standard. The basic level means that the score is within the majority of the test takers. Competent means that several correct answers are attained.</span><span style={{ fontFamily: 'Calibri' }}>&nbsp;&nbsp;</span></li>
                        </ul>
                        {
                           graph_data !== null &&
                           <div style={{ marginTop: "20px", paddingLeft: '120px', paddingRight: "120px" }}>
                              <Bar options={graph_options} data={graph_data} />
                           </div>
                        }


                        <div style={{ pageBreakBefore: 'always' }}></div>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', lineHeight: 'normal' }}><strong>&nbsp;</strong></p>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', lineHeight: 'normal', fontSize: '12pt' }}><strong>Summary of Results</strong></p>
                        <table cellSpacing={0} cellPadding={0} style={{ border: '0.75pt solid #cccccc', borderCollapse: 'collapse', width: '100%' }}>
                           <tbody>
                              <tr>
                                 <td style={{ width: '197.1pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                    <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>Areas</span></strong></p>
                                 </td>
                                 <td style={{ width: '79.2pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                    <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>Raw Score</span></strong></p>
                                 </td>
                                 <td style={{ width: '61.2pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                    <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>Percent Correct</span></strong></p>
                                 </td>
                                 <td style={{ width: '59.9pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                    <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>Standard Score</span></strong></p>
                                 </td>
                                 <td style={{ width: '99.4pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', borderLeftStyle: 'solid', borderLeftWidth: '1pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                    <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>Proficiency Level</span></strong></p>
                                 </td>
                              </tr>
                              {DiagnosticReportUtils.renderSummaryRow("Knowing who we are and our families", knowing, 7, 6.3, 1.22)}
                              {DiagnosticReportUtils.renderSummaryRow("Exploring my Community", exploring, 6, 5.37, 0.8)}
                              {DiagnosticReportUtils.renderSummaryRow("Appreciating our Country", appreciating, 4, 2.92, 1.02)}
                              {DiagnosticReportUtils.renderSummaryRow("Caring for the World", caring, 3, 2, 0.92)}
                              {DiagnosticReportUtils.renderSummaryRow("Total", knowing + exploring + appreciating + caring, 20, 16.73, 2.87)}
                           </tbody>
                        </table>

                        <InterpretationInd backgroundColor='#4F81BD' />

                        <p style={{ marginTop: '0pt', marginBottom: '10pt' }}>&nbsp;</p>
                        <p style={{ marginTop: '0pt', marginBottom: '10pt' }}><strong>Name:&nbsp;</strong>{reportData.student_name}</p>
                     </div>
                  </div>
                  :
                  <div className='center-empty-space'>
                     <Empty
                        description='No Data Found'
                        image="../images/brainee_mascot.png"
                     />
                  </div>
         }
      </>
   );
}